import type { NetworkFields, UserFields } from '@ms/yammer-graphql';

import type { User } from '../../../state/types';
import type { Override } from '../../types';

import { processUserAvatar } from './avatar';

export interface PreNormalizedTypes {
  readonly networkId: NetworkFields;
  readonly originNetwork: UserFields;
}

type PreNormalizedUserTypes = Override<User, PreNormalizedTypes>;

export const processUser: (value: UserFields) => PreNormalizedUserTypes = (value) => ({
  id: value.id,
  networkId: value.network,
  name: value.displayName,
  email: value.email,
  jobTitle: value.jobTitle || undefined,
  databaseId: value.databaseId,
  officeUserId: value.officeUserId || undefined,
  telemetryId: value.telemetryId,
  isGuest: value.isGuest,
  reactionAccentColor: 'NONE',
  sashImageUrl: value.campaignSash?.campaign.sashImageUrl || undefined,
  sashCampaignId: value.campaignSash?.campaign.id || undefined,
  originNetwork: value,
  ...processUserAvatar(value),
});
